import React from 'react';
import { CircularProgress } from '@jpmuitk/progress';
import { ColumnLayout } from "@jpmuitk/column-layout";
import { useTranslation } from 'react-i18next';
import { Card } from '@jpmuitk/card';

export default function LoadingScreen() {
  const { t } = useTranslation();

  const CircularShowNoInfo = () => (
    <CircularProgress aria-label="Download" showInfo={false} variant="indeterminate" />
  );

  return (
    <Card style={{ width: '100%', maxWidth: 850, minHeight: 450, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <ColumnLayout container spacing={3} justify="center" alignItems="center">
        <ColumnLayout item>
          <CircularShowNoInfo style={{margin: 0}}/>
        </ColumnLayout>
        <ColumnLayout item>
          <h2 data-testid="translated-test" style={{margin: 0, padding: 0}}>
            {t('verifying_account')}
          </h2>
          <p data-testid="verifying-test" style={{margin: 0, paddingTop: 4, fontSize: '14px'}}>
            {t('dont_close')}
          </p>
        </ColumnLayout>
      </ColumnLayout>
    </Card>
  );
}
